import app from "../../utils/app.js"
import { el, mount, setChildren } from "redom"
import { openRecordOnClick } from "../pages/recordpage.js"
import { getRecordsHistoryIndex } from "./shared-record-path.js"
import { isApp } from '../../utils/app-type-checker.js'
import { showRecordContent } from "../../utils/common.js"
import { isTopLocation, display } from "./layoutwithapp.js"

export function resetInnerHtmlForAll() {
    const recordApp = document.getElementById("record-app")
    if(recordApp) recordApp.style.display = "block"
    showRecordContent()
    const elements = ["records-page", "allContent", "templateBackground", "likeModal"]
    elements.forEach(item => resetInnerHtml(document.getElementById(item)))
    function resetInnerHtml(item: HTMLElement | null) {
        if (!item) return
        while (item.firstChild)
            item.removeChild(item.firstChild)
    }
    Array.from(document.getElementsByClassName("modal-backdrop")).forEach( el => el.remove())
    Array.from(document.getElementsByClassName("popover")).forEach( el => el.remove())
}

export function setAllContent() {
    const allContent = document.getElementById("allContent")
    if(allContent) setChildren(allContent, el(".sc-section", el("", { id: "recordPost" })))
}

export const initButtons = () => {
    display("previous-button", hasPrevious())
    display("phone-feature", !hasPrevious() && isApp() && !isTopLocation())
    display("backToApp-button", isApp())
    display("go-tuner-button", isApp() && app.isAllowedTo("goTuner"))
    display("add-record-button", isApp())
    display("search-button", false)
    display("bottom-link", !isApp())
    display("web-feature", !isApp())
}

const hasPrevious = () => isApp() && getRecordsHistoryIndex() > 0

export function updateToPost(recordId: string, list = "") {
    window.scrollTo(0, 0)
    resetInnerHtmlForAll()
    setAllContent()
    const param = list? '?list=' + list : ''
    openRecordOnClick('/r/' + recordId + param)
}

export const initTemplateBackground = () => {
    const backgroundColor = "#E8E8E8"
    const addShade = (width: string, height: string, extraParam="", name = "") => el("", { className: name, style: `width: ${width}; height: ${height}; background-color: ${backgroundColor}; ${extraParam}` })

    const emptyRecords = (number: number) => {
        const template = document.createDocumentFragment()
        for (let i = 0; i < number; i++) {
            mount(template, el("h3.pb-2 mb-2 border-bottom", { style: "margin: 0;" }))
            mount(template, el(".row noPadding" , { style: "width: 100%;" },
                el(".col-auto", addShade("62px", "62px", "margin: 0px; ", "rounded")),
                el(".col recordItemDiv", { style: "width: 50%; "},
                    addShade("100px", "15px", "margin-bottom: 5px;"),
                    addShade("100px", "15px", "margin-bottom: 5px;"),
                    addShade("100px", "15px"))))
        }
        return template
    }

    const emptyRecordSections = (number: number) => {
        const template = document.createDocumentFragment()
        for (let i = 0; i < number; i++) {
            mount(template, el(".row sc-section-divider"))
            mount(template, el("", { style: "height: auto; padding: 15px 0;" },
                el(".row", { style: "margin: 0 0 5px; height: 27px; width: 100%"},
                    addShade("30%", "100%"),
                    addShade("10%", "100%", "float: right;", "ms-auto")),
                emptyRecords(3),
                el("center", addShade("100px", "35px"))))
        }
        return template
    }

    const templateBackground = document.createDocumentFragment()
    mount(templateBackground,
        el(".sc-section", { style: "height: auto; padding: 15px 0;" },
          el(".row", { style: `margin: 10px 15px 10px 15px; height: 80px; background-color: ${backgroundColor};` }),
          addShade("auto", "55px", "margin: 5px 15px 10px 15px;"),
          addShade("auto", "55px", "margin: 44px 15px 10px 15px;"),
          el("", { style: "margin: 10px 15px 10px 15px; width: 100%; height: 46px;" },
            addShade("75px", "30px", "margin: 0px 15px; float: right;"))))
    mount(templateBackground, emptyRecordSections(2))

    const templateBackgroundEl = document.getElementById("templateBackground")
    if(templateBackgroundEl) mount(templateBackgroundEl, templateBackground)
}


export const setCollapseRecordList = (collapseId: string, recordsLeft: number) => setCollapseList(collapseId, "record", recordsLeft)
export const setCollapseCommentList = (commentsLeft: number) => setCollapseList("comment", "comment", commentsLeft)
export const setCollapseActivityList = (activitiesLeft: number) => setCollapseList("recentActivity", "", activitiesLeft)

export const getShowMoreText = (content: string, numberLeft: number) => `Show ${numberLeft} more ${content}${numberLeft > 1 && content != "" ? "s" : ""}`
const setCollapseList = (collapseId: string, content: string, numberLeft: number) => {
    const collapseEl = document.getElementById(collapseId + "Collapse");
    const buttonEl = document.getElementById(collapseId + "BtnCollapse");

    if (!collapseEl || !buttonEl) return;
    collapseEl.addEventListener('shown.bs.collapse', () => {
        buttonEl.innerHTML = `<i class="fas fa-angle-up collapseIcon"></i>Show less`;
    });

    collapseEl.addEventListener('hidden.bs.collapse', () => {
        const text = getShowMoreText(content, numberLeft);
        buttonEl.innerHTML = `<i class="fas fa-angle-down collapseIcon"></i>${text}`;
    });
};
